'use client'

import React from 'react';
import { useTranslations } from 'next-intl';

export default function GDPRStatement() {
  const t = useTranslations('gdpr');
  return (
    <section className="bg-background text-foreground p-6 rounded-lg shadow">
      <h1 className="text-2xl font-bold mb-4">{t('title')}</h1>
      <p className="mb-4">{t('content')}</p>
    </section>
  );
}
